import React from 'react';
import {
  AlertCircle, AlertTriangle, ArrowDownAZ, ArrowLeft, ArrowUpAZ,
  BarChart2, Building2, Calendar, Check, CheckCircle, CheckSquare,
  ChevronDown, ChevronLeft, ChevronRight, ChevronUp, ChevronsLeft, ChevronsRight, ChevronsUpDown,
  ClipboardEdit, ClipboardList, Copy, CreditCard, Download,
  Edit2, Edit3, Eye, FileDown, FileQuestion, FileText, Filter,
  GitMerge, HelpCircle, History, Home, Info, Layers, LayoutGrid, List, Loader, LogOut,
  Mail, Map, MapPin, Menu, MoreVertical, Paperclip, Pencil, Phone,
  Plus, PlusCircle, RefreshCw, RotateCcw, Save, Search, SearchX, Send, SlidersHorizontal,
  Star, Tag, Trash2, Upload, User, UserCheck, UserPlus, UserSearch, UserX, Users,
  X, Zap,
} from 'lucide-react';

// Static map → tree-shakeable. Only icons actually referenced in the app are bundled.
const ICONS = {
  AlertCircle, AlertTriangle, ArrowDownAZ, ArrowLeft, ArrowUpAZ,
  BarChart2, Building2, Calendar, Check, CheckCircle, CheckSquare,
  ChevronDown, ChevronLeft, ChevronRight, ChevronUp, ChevronsLeft, ChevronsRight, ChevronsUpDown,
  ClipboardEdit, ClipboardList, Copy, CreditCard, Download,
  Edit2, Edit3, Eye, FileDown, FileQuestion, FileText, Filter,
  GitMerge, History, Home, Info, Layers, LayoutGrid, List, Loader, LogOut,
  Mail, Map, MapPin, Menu, MoreVertical, Paperclip, Pencil, Phone,
  Plus, PlusCircle, RefreshCw, RotateCcw, Save, Search, SearchX, Send, SlidersHorizontal,
  Star, Tag, Trash2, Upload, User, UserCheck, UserPlus, UserSearch, UserX, Users,
  X, Zap,
};

function Icon({
  name,
  size = 24,
  color = "currentColor",
  className = "",
  strokeWidth = 2,
  ...props
}) {
  const IconComponent = ICONS[name];

  if (!IconComponent) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(`<Icon name="${name}" /> not registered in AppIcon.jsx`);
    }
    return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
  }

  return (
    <IconComponent
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      className={className}
      {...props}
    />
  );
}
export default Icon;
